import { useForethoughtWidget } from "../hooks/useForethoughtWidget";

/**
 * Loads the Forethought Solve support widget for signed-in users (rendered
 * from App gated on `user`). The widget stays hidden until opened from the
 * Support sidebar link via `openForethoughtWidget()`, so this renders nothing.
 */
export function ForethoughtWidget() {
  useForethoughtWidget();
  return null;
}
